import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import CliffLayout from "./screens/Route/CliffLayout";
import MultipitchLayout from "./screens/Route/MultipitchLayout";
import PresentationScreen from "./screens/Route/PresentationScreen";
import MyRouteListScreen from "./screens/Route/MyRouteListScreen";
import SearchScreen from "./screens/Route/SearchScreen";
import TopoListScreen from "./screens/Route/TopoListScreen";
import TopoScreen from "./screens/Route/TopoScreen";
import NoMatch from "./components/NoMatch";
import TopoValidationScreen from "./screens/Route/TopoValidationScreen";
import {PWAUrlsParams} from "./config/urls";
import Constants from "./config/constants";


export default function RouteRouter({from = Constants.ROUTER.ROUTE}) {
    return (<>
        <Routes>
            {from === Constants.ROUTER.ROUTE && <Route path={"/"}
                   element={<MyRouteListScreen/>}/>}
            {from === Constants.ROUTER.TOPOS && <Route path={"/"}
                             element={<TopoListScreen/>}/>}
            {from === Constants.ROUTER.SEARCH && <Route path={"/"}
                            element={<SearchScreen/>}/>}
            {from === Constants.ROUTER.PRESENTATION && <Route
                    path={"/:slugpresentation"}
                    element={<PresentationScreen/>}
                />}

            {from === Constants.ROUTER.TOPO && <Route
                path={"/:slug/" + PWAUrlsParams.routeTypeCliff.en + "/:slugregion/:slugfalaise/*"}
                element={<CliffLayout/>}/>}
            {from === Constants.ROUTER.TOPO && <Route
                path={"/:slug/"+ PWAUrlsParams.routeTypeCliff.fr + "/:slugregion/:slugfalaise/*"}
                element={<CliffLayout/>}/>}
            {from === Constants.ROUTER.TOPO && <Route
                path={"/:slug/" + PWAUrlsParams.routeTypeMultipitch.en + "/:slugregion/:slugvoie/*"}
                element={<MultipitchLayout/>}
            />}
            {from === Constants.ROUTER.TOPO && <Route
                path={"/:slug/"+ PWAUrlsParams.routeTypeMultipitch.fr + "/:slugregion/:slugvoie/*"}
                element={<MultipitchLayout/>}
            />}

            {from === Constants.ROUTER.ROUTE && <Route
                path={"/" +  PWAUrlsParams.routeTypeCliff.en + "/:slugregion/:slugfalaise/*"}
                element={<CliffLayout/>}/>}
            {from === Constants.ROUTER.ROUTE && <Route
                path={"/" + PWAUrlsParams.routeTypeCliff.fr + "/:slugregion/:slugfalaise/*"}
                element={<CliffLayout/>}/>}
            {from === Constants.ROUTER.ROUTE && <Route
                path={"/" + PWAUrlsParams.routeTypeMultipitch.en + "/:slugregion/:slugvoie/*"}
                element={<MultipitchLayout/>}
            />}
            {from === Constants.ROUTER.ROUTE && <Route
                path={"/" + PWAUrlsParams.routeTypeMultipitch.fr + "/:slugregion/:slugvoie/*"}
                element={<MultipitchLayout/>}
            />}

            {from === Constants.ROUTER.TOPO && <Route path={"/:slug/validation"} element={<TopoValidationScreen/>}/>}
            {/*{from === Constants.ROUTER.TOPO && <Route path={"/:slug/activation"} element={<ActivationScreen/>}/>}*/}
            {/*{from === Constants.ROUTER.TOPO && <Route path={"/:slug/activation/:token"} element={<ActivationScreen/>}/>}*/}

            {from === Constants.ROUTER.TOPO && <Route
                path={"/:slug"}
                element={<TopoScreen/>}
            />}

            <Route path={'*'} element={<NoMatch/>}/>
        </Routes>
        {from === Constants.ROUTER.SEARCH && window.location.pathname !== ('/fr/' + PWAUrlsParams.search.fr)
            && window.location.pathname !== ('/en/' + PWAUrlsParams.search.en)
            && <Navigate path={"/*"} to={window.location.pathname
                .replace('/' + PWAUrlsParams.search.fr, '/'  +PWAUrlsParams.routes.fr)
                .replace('/' + PWAUrlsParams.search.en, '/'  +PWAUrlsParams.routes.en)
            }
        />}
    </>);
}
